// extracted by mini-css-extract-plugin
export default {"seperator":"Seperator_seperator__R8D3W","solid":"Seperator_solid__QjCTy","dashed":"Seperator_dashed__kfDYX","dotted":"Seperator_dotted__xgWhM"};